<template>
 <div class="cascade_box">
    
      <div class="wrapper">
      
        <ul  class="first_wrapper">
            <div class="category_title">{{$t('other.a481')}}</div>
            <li class="first_category active" v-for="(item,index) in countryList" :key="index" @click="cateGory(item,1)">
                <span>{{item.country}}</span>
            </li>
        </ul>
        <ul v-if="firstCategory.length"  class="second_wrapper">
            <div class="category_title">{{$t('other.a482')}}</div>
            <li class="second_category  active" v-for="(itemTwo,indexOne) in firstCategory" :key="indexOne" @click="cateGory(itemTwo,2)">
                <span> {{itemTwo.categoryName}} ({{itemTwo.zhName}})</span>
            </li>
        </ul>
        <ul v-if="secondCategory.length"  class="three_wrapper">
            <div class="category_title">{{$t('other.a483')}}</div>
            <li class="three_category  active" v-for="(itemThree,indexOne) in secondCategory" :key="indexOne" @click="cateGory(itemThree,3)">
                <span>{{itemThree.categoryName}} ({{itemThree.zhName}})</span>
            </li>
        </ul>
        <ul v-if="thirdCategory.length"  class="foth_wrapper">
            <div class="category_title">{{$t('other.a484')}}</div>
            <li class="three_category  active" v-for="(itemThree,indexOne) in thirdCategory" :key="indexOne" @click="cateGory(itemThree,4)">
                <span>{{itemThree.categoryName}} ({{itemThree.zhName}})</span>
            </li>
        </ul>
        <div>
            <el-button type="primary" @click="confirm()">{{$t('other.a279')}}</el-button>
        </div>

       
  </div>

   
 </div>
</template>

<script>
export default {
data(){
return{
    countryList:[],
    firstCategory:[],
    secondCategory:[],
    thirdCategory:[],
    id:[],
    name:[],
    targetItem:null,
    nameCopy:''

}
},
props:{
    cageGoryList:{
        type:Array,
        default:[]
    }
},
watch:{
    cageGoryList(){
        console.log('cageGoryList',this.cageGoryList)
        this.countryList=this.cageGoryList
    }
},
created(){

},
methods:{

    confirm(){
        console.log(this.targetItem)
        
        if(this.targetItem[0].hasChildren){
            targetItem
        }
    },

    cateGory(item,index){
        console.log(item,index)
        this.targetItem=item
        if(index == 1) {
            this.firstCategory=[]
            this.secondCategory=[]
            this.thirdCategory=[]
            this.name.splice(index-1)
            this.name.push(item.country)
            item.data.forEach(p => {
                this.firstCategory.push({
                    categoryName:p.categoryName,
                    hasChildren:p.hasChildren,
                    childrens:p.childrens,
                    zhName:p.zhName,
                })
            }) 
        }
        if(index == 2) {
            this.name.splice(index-1)
            this.name.push(item.categoryName)
            this.secondCategory=[]
            this.thirdCategory=[]
            if(item.hasChildren){
                 item.childrens.forEach(p => {
                this.secondCategory.push({
                        categoryName:p.categoryName,
                        hasChildren:p.hasChildren,
                        childrens:p.childrens,
                        zhName:p.zhName
                    })
                })
            }
           
        }
        if(index === 3){
            this.name.splice(index-1)
            this.name.push(item.categoryName)
            this.thirdCategory=[]
            if(item.hasChildren){

                item.childrens.forEach(p => {
                    this.thirdCategory.push({
                        categoryName:p.categoryName,
                        hasChildren:p.hasChildren,
                        childrens:p.childrens,
                        zhName:p.zhName
                    })
                })
            }
        }

        if(index === 4) {
           
            this.name.push(item.categoryName)
        }

        let name=this.name.join('/')
        this.$emit('updataName',name)

        console.log(this.name,name)
    },

}
}

</script>
<style scoped lang='scss'>
.cascade_box{
    background-color: #fff;

    .wrapper{
        position: absolute;
        top: 0;
        left: 0;
        background-color: #fff;
        display: flex;
        max-width: 800px;
        overflow-x: hidden;
     

    }

    .btn{
        position: absolute;
        top:350px;
        right: -800px;
        display: flex;
        background-color: #fff;
        width: 800px;
        text-align: right;
    }

    .first_wrapper{
        width: 200px;
        height: 350px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;
        .first_category{
            cursor: pointer;
            padding: 0 10px;
            border-bottom: 1px solid #eee;
        }
    }

    .second_wrapper{
        width: 300px;
        height: 350px;
        overflow-y: scroll;
        z-index: 99;
        background-color: #fff;
        .second_category{
            cursor: pointer;
            padding: 0 10px;
            border-bottom: 1px solid #eee;
        }
    }

    .three_wrapper{
            width: 300px;
            height: 350px;
            overflow-y: scroll;
            z-index: 99;
            background-color: #fff;

                .three_category{
                cursor: pointer;
                padding: 0 10px;
                border-bottom: 1px solid #eee;
            }
            

    }

    .foth_wrapper{
            // position: absolute;
            // top: 0;
            // left: 800px;
            width: 300px;
            height: 350px;
            overflow-y: scroll;
            z-index: 99;
            background-color: #fff;

                .three_category{
                cursor: pointer;
                padding: 0 10px;
                border-bottom: 1px solid #eee;
            }
            

    }

   
    
}
</style>